import {
  getPage,
  getByLocationDatetime,
  downloadDailyTracksByCreateDatetime,
  deleteByCreateDatetimeRange,
} from '@/api/gddlysjglocatehistoryserv'

export default {
  state: {
    state_GdDlysjgLocateHistory_GetPageResult: null,
    state_GdDlysjgLocateHistory_GetByLocationDatetimeResult: null,
    state_GdDlysjgLocateHistory_DownloadDailyTracksByCreateDatetimeResult: null,
    state_GdDlysjgLocateHistory_DeleteByCreateDatetimeRangeResult: null,
  },
  mutations: {
    SET_GDDLYSJGLOCATEHISTORY_GETPAGE_RESULT: (state, rst) => {
      state.state_GdDlysjgLocateHistory_GetPageResult = rst;
    },
    SET_GDDLYSJGLOCATEHISTORY_GETBYLOCATIONDATETIME_RESULT: (state, rst) => {
      state.state_GdDlysjgLocateHistory_GetByLocationDatetimeResult = rst;
    },
    SET_GDDLYSJGLOCATEHISTORY_DOWNLOADDAILYTRACKSBYCREATEDATETIME_RESULT: (state, rst) => {
      state.state_GdDlysjgLocateHistory_DownloadDailyTracksByCreateDatetimeResult = rst;
    },
    SET_GDDLYSJGLOCATEHISTORY_DELETEBYCREATEDATETIMERANGE_RESULT: (state, rst) => {
      state.state_GdDlysjgLocateHistory_DeleteByCreateDatetimeRangeResult = rst;
    },
  },
  actions: {
    GdDlysjgLocateHistoryServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_GDDLYSJGLOCATEHISTORY_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_GDDLYSJGLOCATEHISTORY_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    GdDlysjgLocateHistoryServ_GetByLocationDatetime({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getByLocationDatetime(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_GDDLYSJGLOCATEHISTORY_GETBYLOCATIONDATETIME_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_GDDLYSJGLOCATEHISTORY_GETBYLOCATIONDATETIME_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    GdDlysjgLocateHistoryServ_DownloadDailyTracksByCreateDatetime({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        downloadDailyTracksByCreateDatetime(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_GDDLYSJGLOCATEHISTORY_DOWNLOADDAILYTRACKSBYCREATEDATETIME_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_GDDLYSJGLOCATEHISTORY_DOWNLOADDAILYTRACKSBYCREATEDATETIME_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    GdDlysjgLocateHistoryServ_DeleteByCreateDatetimeRange({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        deleteByCreateDatetimeRange(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_GDDLYSJGLOCATEHISTORY_DELETEBYCREATEDATETIMERANGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_GDDLYSJGLOCATEHISTORY_DELETEBYCREATEDATETIMERANGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_GdDlysjgLocateHistory_GetPageResult: state => {
      return state.state_GdDlysjgLocateHistory_GetPageResult;
    },
    get_GdDlysjgLocateHistory_GetByLocationDatetimeResult: state => {
      return state.state_GdDlysjgLocateHistory_GetByLocationDatetimeResult;
    },
    get_GdDlysjgLocateHistory_DownloadDailyTracksByCreateDatetimeResult: state => {
      return state.state_GdDlysjgLocateHistory_DownloadDailyTracksByCreateDatetimeResult;
    },
    get_GdDlysjgLocateHistory_DeleteByCreateDatetimeRangeResult: state => {
      return state.state_GdDlysjgLocateHistory_DeleteByCreateDatetimeRangeResult;
    },
  }
}